export enum PlanType {
  Premium,
  Economy,
  Trial,
}
